module.exports = __webpack_public_path__ + "static/media/pdf.d74a9f95.svg";